import React, {Fragment} from 'react';
import Select from '../../form/Select';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import {
    CurrencyFormatter,
    optionsTemplate,
    ProductColumn,
    remoteOptionFormatter,
    UnitFormatter
} from "../../../utils/formatters";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import DateTimeInput from "../../form/DateTimeInput";
import {get} from "../../../utils/dotutils";

const sortable = true;
const filterable = true;

class CommissionPaymentForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-3">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-sm-3">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="commission"
                            filter={[{field: "business_service_provider", value: this.props.pos.partner.partner_id}]}
                            values={this.props.values}
                            labelKey="commissioner.name"
                            optionsTemplate={(option) => {
                                return <Fragment>{get(option, "commissioner.name")} {remoteOptionFormatter("CommissionProvider")(get(option, "provider"))}</Fragment>;
                            }}
                            selectedOptionTemplate={(option) => {
                                return <Fragment>{get(option, "commissioner.name")} {remoteOptionFormatter("CommissionProvider")(get(option, "provider"))}</Fragment>;
                            }}
                            view={[
                                "commissioner",
                                "provider",
                                "business_service_provider"
                            ]}
                            required={true}
                            setFieldValue={this.props.setFieldValue}
                            label="Forgalmazói megállapodás"
                        />
                    </div>
                    <div className="col-md-3">
                        <Select
                            label="Partner"
                            name="partner"
                            component="partner"
                            objectValue={true}
                            labelKey="name"
                            valueKey="partner_id"
                            storeType="remote"
                            {...this.props.getFieldProps("partner")}
                            value={(this.props.values.commission || {}).commissioner}
                            saveChanges={this.setFieldValue}
                            disabled="disabled"
                        />
                    </div>
                    <div className="col-md-3">
                        <Select
                            label="Szolgátató"
                            name="partner"
                            component="partner"
                            objectValue={true}
                            labelKey="name"
                            valueKey="partner_id"
                            storeType="remote"
                            {...this.props.getFieldProps("partner")}
                            value={(this.props.values.commission || {}).business_service_provider}
                            saveChanges={this.setFieldValue}
                            disabled="disabled"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-4">
                        <DateTimeInput
                            name="fromdate"
                            value={this.props.values.fromdate}
                            label="Dátumtól"
                            required={true}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("fromdate")}
                        />
                    </div>
                    <div className="col-sm-4">
                        <DateTimeInput
                            name="todate"
                            value={this.props.values.todate}
                            label="Dátumig"
                            required={true}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("todate")}
                        />
                    </div>
                    <div className="col-sm-4 currency">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="amount"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            formatter={CurrencyFormatter}
                            label="Nettó összeg"
                            disabled="disabled"
                        />
                    </div>
                </div>
                {this.props.values[this.props.componentConfig.idfield] && <div className="row form-row">
                    <div className="col-md-12">
                        <SelectorGrid
                            {...this.props.getFieldProps("items")}
                            ref={(e) => this.items = e}
                            className={"p-small-table"}
                            exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel"}]}
                            addRowProps={{
                                optionsTemplate: optionsTemplate("product")
                            }}
                            aggregations={{
                                fields: {
                                    "qty": {
                                        field: "qty", type: "SUM"
                                    },
                                    "amount": {
                                        field: "amount", type: "SUM"
                                    },
                                }
                            }}
                            view={["component_type", "component_id"]}
                            columns={{
                                ...(this.props.values.commission.provider === "PackagePickup" ? {
                                    "component_id": {
                                        header: 'Tranzakció azonosító',
                                        width: 1,
                                        sortable,
                                        filterable
                                    },
                                } : {
                                    "displayname": {
                                        ...ProductColumn("component_id", (r, ...args) => {
                                            if (args[1].component_type === "product") {
                                                return r(...args);
                                            } else {
                                                return args[0];
                                            }
                                        }),
                                        width: 2,
                                    },
                                    "barcode": {
                                        header: 'Vonalkód',
                                        width: 1,
                                        sortable,
                                        filterable
                                    },
                                }),
                                "baseprice": {
                                    header: 'Számolási alap',
                                    width: 2,
                                    sortable,
                                    filterable,
                                    renderer: CurrencyFormatter,
                                    className: "currency"
                                },
                                "qty": {
                                    header: 'Darabszám',
                                    width: 1,
                                    sortable,
                                    filterable,
                                    className: "unit",
                                    renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                                },
                                "amount": {
                                    header: 'Összesen',
                                    width: 2,
                                    sortable,
                                    filterable,
                                    renderer: CurrencyFormatter,
                                    className: "currency"
                                },
                            }}
                            listfield="items"
                            data={this.props.values}
                            orderBy={{field: "displayname", direction: "ASC"}}
                            componentConfig={this.props.componentConfig}
                        />
                    </div>
                </div>}

            </form>
        );
    }
}

export default createForm(CommissionPaymentForm);
